/* Lazy quick view (2026-09-19).
   product-card.liquid ships each card's quick-view markup inside <template class="qv-lazy">.
   On first hover/focus/touch/click of a Quick View button the template is unpacked in place,
   with its scripts re-created so they run exactly as they did when the markup was always in the DOM.
   Revert: restore snippets/product-card.liquid (remove the <template> wrapper) and delete this file. */
(function () {
  function hydrate(id) {
    var tpl = document.querySelector('template.qv-lazy[data-qv-id="' + id + '"]');
    if (!tpl) return;
    var frag = tpl.content.cloneNode(true);
    frag.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      s.text = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
    tpl.parentNode.insertBefore(frag, tpl);
    tpl.remove();
  }
  function idFrom(e) {
    var b = e.target.closest && e.target.closest('a.quick-view[data-id]');
    return b ? b.getAttribute('data-id') : null;
  }
  // Capture phase on document: runs before Fancybox's delegated click handler, so the target exists.
  ['click', 'mouseover', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var id = idFrom(e);
      if (id) hydrate(id);
    }, { capture: true, passive: true });
  });
})();
